<template>
  <div class="team-member" :class="{more: moreOpened, animating}">
    <div class="info-drawer">
      <div class="info-content quotes"v-html="member.quote"></div>
      <div class="info-content bottom">
        <ul>
          <li class="paragraph-1" v-for="box in member.boxes">{{ box.experience }}</li>
        </ul>
      </div>
      <div class="button-container back">
        <seu-button
          :label="moreOpened?  member.buttonLabelLess :member.buttonLabel"
          @click="moreOpened ? closeMore(): openMore()"
        />
      </div>
    </div>

    <div class="team-member-container">
      <div class="main-content">
        <div class="content-wrapper">
          <img :src="member.image" alt="">
        </div>
      </div>
      <div class="main-content">
        <div class="content-wrapper member-info-container">
          <div class="member-name heading-3-bold">{{ member.fullName }}</div>
          <div class="info-wrapper">
            <div class="caps-regular member-position" v-html="member.position"></div>
            <div class="divider"></div>
            <div>
              <a class="action-row" :href="`mailto:${member.email}`">
                <img class="member-icon" src="../assets/icons/mail-icon.svg" alt="">
                <div>{{ member.email }}</div>
              </a>
              <a class="action-row" :href="`tel:${member.phone}`">
                <img class="member-icon" src="../assets/icons/phone-icon-black.svg" alt="">
                <div>{{ member.phone }}</div>
              </a>
              <div class="socials-container action-row">
                <a target="_blank" :href="member.linkedin" v-if="member.linkedin">
                  <img class="member-icon" src="../assets/icons/linkedin-icon.svg" alt="">
                  <div>LinkedIn</div>
                </a>
                <a :href="`http://www.${member.website}`" target="_blank" v-if="member.website">
                  <img class="member-icon" src="../assets/icons/world-icon.svg" alt="">
                  <div>{{ member.website }}</div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="button-container">
        <seu-button
          :label="moreOpened?  member.buttonLabelLess :member.buttonLabel"
          @click="moreOpened ? closeMore(): openMore()"
        />
      </div>
    </div>
    <!--    <div v-if="false" class="team-member-bio" v-html="member.bio">-->

  </div>
</template>

<script>
import SeuButton from "/seu-frontend/components/SeuButton";

export default {
  name: "TeamMember",
  components: {SeuButton},
  props: {
    member: {
      type: Object,
      required: true
    },

  },
  data: () => ({
    moreOpened: false,
    animating: false
  }),

  methods: {
    openMore() {
      clearTimeout(this.timeout)
      this.moreOpened = true
      this.animating = true
      this.$emit('opened')
    },
    closeMore() {
      this.moreOpened = false
      this.timeout = setTimeout(() => {
        this.animating = false
      }, 300)
    }
  }

}
</script>

<style lang="scss">
@import "TeamMember.scss";
</style>
